var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF2BC2",
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_radial)",
    d: "M2.39999 23.9999C2.39999 12.0706 12.0707 2.3999 24 2.3999C35.9293 2.3999 45.6 12.0706 45.6 23.9999C45.6 35.9292 35.9293 45.5999 24 45.5999C12.0707 45.5999 2.39999 35.9292 2.39999 23.9999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FED7F0",
    fillRule: "evenodd",
    d: "M24.7064 32.506L20.1564 23.6824L24.4464 15.4437C24.5276 15.2975 24.4789 15.2 24.3489 15.2H21.7326C21.5721 15.2 21.5226 15.2792 21.4431 15.4064L21.4401 15.4112C21.1711 15.989 20.8985 16.5691 20.6252 17.1507C19.8915 18.7119 19.1531 20.2833 18.4664 21.8461H18.4339C17.7169 20.2449 16.9648 18.6701 16.2099 17.0892C15.9382 16.5203 15.6661 15.9507 15.3952 15.3787C15.3464 15.2325 15.2652 15.2 15.1027 15.2H12.3077C12.194 15.2 12.0965 15.3137 12.194 15.4437L16.5002 23.9586L12.0477 32.5223C11.9665 32.6198 11.9827 32.7498 12.1452 32.7498H14.8427C14.9727 32.7498 15.0539 32.701 15.1352 32.571C16.1752 30.4261 17.2477 28.0536 18.2227 25.8761H18.2552C19.3439 28.1836 20.4001 30.4098 21.4401 32.5548C21.5214 32.7173 21.6026 32.766 21.7814 32.766H24.6089C24.7389 32.766 24.7876 32.636 24.7064 32.506ZM25.6976 26.3149C25.6976 22.5286 28.1351 19.5712 32.1325 19.5712C32.4738 19.5712 32.6525 19.5712 32.9775 19.6037V15.3787C32.9775 15.2812 33.0588 15.2162 33.14 15.2162H35.7563C35.8863 15.2162 35.9188 15.265 35.9188 15.3462V30.1986C35.9188 30.6373 35.9188 31.1898 36 31.7911C36 31.9048 36 31.9211 35.9025 31.9698C34.5375 32.6198 33.1075 32.9123 31.7425 32.9123C28.2163 32.9123 25.6976 30.7348 25.6976 26.3149ZM32.9775 22.1549C32.7338 22.0411 32.425 21.9924 32.035 21.9924C29.9876 21.9924 28.6226 23.5686 28.6226 26.1849C28.6226 29.1748 30.0201 30.3773 31.84 30.3773C32.23 30.3773 32.6525 30.3286 32.9613 30.1986V22.1549H32.9775Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(19.623 16.79) scale(28.1648)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E0E17",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.767,
    stopColor: "#0E0E17"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXd);
export default __webpack_public_path__ + "static/media/xd.f38c16c7dea217ddb09976d44fcb1184.svg";
export { ForwardRef as ReactComponent };